import {useCallback} from 'react';
import {useModal} from 'extensions/viewport/useModal';
import {ModalStorageUpsell, StorageUpsellAction} from 'interface/stacks/ModalStorageUpsell';
import {isUpsellDeniedPlatform} from 'utils/platform';

export const STORAGE_OVER_THRESHOLD_PERCENT = 99;
export const STORAGE_REMIND_THRESHOLD_PERCENT = 95;
export const STORAGE_WARN_THRESHOLD_PERCENT = 85;
const DISMISS_KEY = 'mf-storage-upsell-remind-dismissed-at';
const DISMISS_COOLDOWN_MS = 12 * 60 * 60 * 1000;

export function wasRecentlyDismissed() {
  try {
    const stamp = Number(window.localStorage.getItem(DISMISS_KEY));
    return stamp > 0 && Date.now() - stamp < DISMISS_COOLDOWN_MS;
  } catch {
    return false;
  }
}

function recordDismiss() {
  try {
    window.localStorage.setItem(DISMISS_KEY, String(Date.now()));
  } catch {}
}

export function useModalStorageUpsell(action: StorageUpsellAction) {
  const modal = useModal();
  const exit = useCallback(() => {
    if (action === 'remind') recordDismiss();
    modal.exit();
  }, [action]);
  const show = useCallback((needed: number = 0, limit: number = 0) => {
    if (isUpsellDeniedPlatform()) return;
    if (action === 'remind' && wasRecentlyDismissed()) return;
    modal.open(
      <ModalStorageUpsell
        exit={exit}
        action={action}
        needed={needed}
        limit={limit}
      />,
      {frameless: true},
    );
  }, [action]);
  return [show, exit] as const;
}
